export default __webpack_public_path__ + "static/media/backArrow.f4420888.svg";